import React, { useEffect, useState } from 'react';
import CustomerKYC from './CustomerKYC';
import { useNavigate } from 'react-router-dom';
import { fetchCustomerById } from '../utils/api/api';
import { MdEdit, MdOutlineAttachment } from 'react-icons/md';
import { FaRegUser } from 'react-icons/fa';
import CustomerInfo from './CustomerInfo';
import Loading from '../elements/Loading';
import Layout from '../elements/Layout';
import Cookies from 'js-cookie';

const Account = () => {
  const [activeTab, setActiveTab] = useState('Info');
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const customerId = Cookies.get('user_id');

  useEffect(() => {
    const getCustomer = async () => {
      try {
        const data = await fetchCustomerById(customerId);
        setCustomer(data.customer);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    getCustomer();
  }, [customerId]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Info':
        return <CustomerInfo customer={customer} />;
      case 'Documents':
        return <CustomerKYC />;
      default:
        return <CustomerInfo customer={customer} />;
    }
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50">
        {loading && <Loading />}

        <div className="max-w-lg mx-auto px-4 py-6">
          <header className="mb-6">
            <h1 className="text-xl font-medium text-gray-900">Account</h1>
          </header>

          <div className="mb-6 bg-white rounded-lg p-4">
            <div className="flex items-start gap-4">
              <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-100 flex-shrink-0">
                <img
                  className="w-full h-full object-cover"
                  src="https://imgs.search.brave.com/fbxInw05M6mkNEHaT64Qm3dNEzTIVXrwCD4lxk4ve3A/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly90NC5m/dGNkbi5uZXQvanBn/LzAyLzE3LzM0LzY3/LzM2MF9GXzIxNzM0/Njc4Ml83WHBDVHQ4/YkxOSnF2VkFhRFpK/d3Zaam0wZXBRbWo2/ai5qcGc"
                  alt="Profile"
                />
              </div>
              
              <div className="flex-1">
                <h2 className="text-lg font-medium text-gray-900">
                  {customer?.first_name} {customer?.last_name}
                </h2>
                <p className="text-sm text-gray-500 mb-2">{customer?.email}</p>
                
                <div className="flex flex-wrap gap-2">
                  {customer?.nationality && (
                    <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded-full">
                      {customer.nationality}
                    </span>
                  )}
                  {customer?.id_number && (
                    <span className="px-2 py-0.5 bg-gray-100 text-gray-700 text-xs rounded-full">
                      ID: {customer.id_number.substring(0, 6)}•••
                    </span>
                  )}
                </div>
              </div>
              
              <button
                onClick={() => navigate('/dashboard/account/edit')}
                className="p-2 rounded-full text-gray-500 hover:bg-gray-100"
                aria-label="Edit profile"
              >
                <MdEdit size={18} />
              </button>
            </div>
          </div>

          <div className="flex mb-4 border-b border-gray-200">
            <button
              className={`py-3 px-4 text-sm font-medium flex items-center gap-2 border-b-2 transition-colors ${
                activeTab === 'Info'
                  ? 'border-gray-900 text-gray-900'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
              onClick={() => setActiveTab('Info')}
            >
              <FaRegUser size={14} />
              <span>Info</span>
            </button>
            <button
              className={`py-3 px-4 text-sm font-medium flex items-center gap-2 border-b-2 transition-colors ${
                activeTab === 'Documents'
                  ? 'border-gray-900 text-gray-900'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
              onClick={() => setActiveTab('Documents')}
            >
              <MdOutlineAttachment size={16} />
              <span>Documents</span>
            </button>
          </div>

          <div className="pb-16">
            {renderTabContent()}
          </div>
          
          <div className="fixed bottom-20 right-4 md:hidden">
            <button
              onClick={() => navigate('/dashboard/account/edit')}
              className="w-12 h-12 rounded-full flex items-center justify-center bg-gray-900 text-white shadow-lg"
              aria-label="Edit profile"
            >
              <MdEdit size={20} />
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Account;